<template>
    <div class="login-page-wrapper profile" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="container ">
            <div class="row" :class="{ hidden: isHidden() }">
                <div class="col-md-12">
                    <div class="main-content">
                        <h3 class="heading" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">Terms of Service</h3>
                    </div>
                </div>
                <div class="col-md-12 text-left">
                    <p>
                        Last Modified: October 25, 2017
                    </p>
                    <p>
                        These Terms of Service ("<strong>Terms of Service</strong>") govern your
                        access to and use of the website located at <a href="https://tonenetworks.com" target="_blank">https://tonenetworks.com
                    </a>
                        (the "<strong>Website</strong>"), including any content, functionality and
                        services offered on or through the Website, memberships, and any of our
                        other products or services (collectively referred to as the "    <strong>Services</strong>"). The Website is owned and operated by ChartOne
                        Media LLC, a Delaware limited liability company ("<strong>ChartOne</strong>
                        ", "<strong>we</strong>" or "<strong>us</strong>").
                    </p>
                    <p>
                        Please read the Terms of Service carefully before using the Services
                        because they contain provisions that affect your rights and obligations,
                        including a mandatory arbitration provision and a waiver of your right to
                        participate in a class action. By using the Services, you accept and agree
                        to be bound and abide by these Terms of Service and our Privacy Policy,
                        found at
                        <a  href="https://tonenetworks.com/privacypolicy" target="_new">
                            https://tonenetworks.com/privacypolicy
                        </a>
                        ("<strong>Privacy Policy</strong>"), which are incorporated herein by
                        reference. If you do not want to agree to these Terms of Service or the
                        Privacy Policy, you must not access or use the Services.
                    </p>
                    <p>
                        The Services are offered and available to individuals who are 18 years of
                        age or older. By using the Services, you represent and warrant to ChartOne
                        that you are 18 years of age or older and are otherwise capable of forming
                        a legally binding contract with ChartOne, and that your use of the Services
                        is consistent with our Terms of Service, our Privacy Policy, and all
                        applicable law. If you do not meet these requirements, you must not access
                        or use the Services.
                    </p>
                    <p>
                        You acknowledge and confirm that (i) you have read and understand all of
                        the terms, conditions, policies, provisions, disclosures and disclaimers
                        contained herein, (ii) these Terms of Service have the same force and
                        effect as a signed agreement, and (iii) you expressly accept and agree to
                        be bound by the terms hereof.
                    </p>
                    <p>
                        <strong>Changes to these Terms of Service</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        We may modify these Terms of Service at any time in our sole discretion. We
                        will post notice of changes to these Terms of Service on this page. Changes
                        will not apply retroactively and will only become effective when (i) you
                        use the Services after you know about the change, or (ii) thirty (30) days
                        after they are posted, whichever is sooner. However, changes addressing new
                        functions for a Service or changes made for legal reasons will be effective
                        immediately. We will also update the Last Modified Date at the top of these
                        Terms of Service accordingly. Your continued use of the Services after the
                        Last Modified Date signifies your consent to the modified Terms of Service.
                        You are expected to check this page frequently so you are aware of any
                        changes, as they are binding on you. If the modified Terms of Service are
                        not acceptable to you, you should not access or use the Services after the
                        Last Modified Date and may cancel your membership (see "Cancellations"
                        below).
                    </p>
                    <p>
                        <strong>Data Privacy and Personal Information</strong>
                        <strong></strong>
                    </p>
                    <p>
                        By agreeing to these Terms of Service, you also consent to our Privacy
                        Policy, which is incorporated by reference into these Terms of Service. If
                        you live outside the United States, by agreeing to these Terms of Service
                        you consent to the transfer and processing of your personal information in
                        the United States in accordance with the Privacy Policy and U.S. law.
                    </p>
                    <p>
                        You should not submit or upload personal information or any other
                        information about yourself or others that you are not comfortable
                        disclosing to the general public. This information will be viewable by
                        other users of the Services, may be searchable on indexing websites such as
                        Google, and may be disclosed to third parties under certain circumstances
                        as provided in our Privacy Policy.
                    </p>
                    <p>
                        By agreeing to these Terms of Service and our Privacy Policy, you
                        acknowledge and agree that we have the right to display any or all of the
                        information on your profile in our marketing materials and on our Website
                        without obtaining your permission.
                    </p>
                    <p>
                        <strong>International Users</strong>
                        <strong></strong>
                    </p>
                    <p>
                        ChartOne and the Services are operated from within the United States. If
                        you access the Services from a location outside the United States, you are
                        responsible for compliance with the laws of that jurisdiction regarding
                        online conduct and acceptable content. ChartOne makes no claim that the
                        content of the Services may be utilized, accessed or appropriate outside
                        the United States. You must not access or use the Services from a territory
                        that is embargoed by the United States or from which it is illegal to
                        receive products, services, or software from the United States.
                    </p>
                    <p>
                        <strong>Third Party Links</strong>
                        <strong></strong>
                    </p>
                    <p>
                        The Services may link to independent third-party websites or social media
                        widgets. Such hyperlinks are provided for your reference and convenience
                        only. ChartOne is not liable for the availability or accuracy of such
                        third-party sources, and you assume all risk in using them. When you link
                        to them, these third-party sites or services may place cookies and other
                        tracking technologies on your computer and may have different rules for
                        using or sharing any personal information you submit to them. By using such
                        third-party sources, sites, and/or sources, you agree to be bound by the
                        terms, privacy policy, and other policies of such third-parties. We
                        encourage you to read their privacy policies before submitting your
                        personal information.
                    </p>
                    <p>
                        When you access third party websites or interact or communicate with third
                        parties through the Services, you do so at your own risk. ChartOne is not
                        responsible for the actions, content, information, data, practices,
                        policies or opinions of any third parties. You are solely responsible for
                        your interactions with third parties and you should make whatever
                        investigation you feel necessary or appropriate before proceeding with any
                        online or offline interaction with any other person.
                    </p>
                    <p>
                        If you have a dispute with one more third party websites or third parties,
                        you hereby release us (and our officers, directors, agents, subsidiaries,
                        joint ventures and employees) from claims, demands and damages (actual and
                        consequential) of every kind and nature, known and unknown, arising out of
                        or in any way connected with such disputes, including damages for loss of
                        profits, goodwill, use, privacy or data. We reserve the right, but have no
                        obligation, to become involved in any way with these disputes. If you are a
                        California resident, you waive California Civil Code &#167;1542, which
                        says: "A general release does not extend to claims which the creditor does
                        not know or suspect to exist in his or her favor at the time of executing
                        the release, which if known by him or her must have materially affected his
                        settlement with the debtor." And, if you are not a California resident, you
                        waive any applicable state statutes of a similar effect.
                    </p>
                    <p>
                        <strong>Registration</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        Using the Services requires you to create an account and accept our Terms
                        of Service. To create an account, you must provide your email address, address, date of birth, and an accepted form of
                        payment
                        (see "Payment Methods" below). You may also select one or more areas of
                        interests.
                    </p>
                    <p>
                        By registering, you represent and warrant: (i) that all of the information
                        that you provide, including any social media profiles and other links that
                        you choose to add to your profile, is correct, current, and complete; (ii)
                        that you have created an account for yourself and have not misrepresented
                        your identity or created a false identity; and (iii) that you have not
                        registered for any illegal purpose, to facilitate any illegal topic, or
                        otherwise for the purpose of providing any illegal information. If you
                        believe that your identity or someone else's identity has been
                        misrepresented, please contact us immediately. You may also report other
                        users who you believe to be in breach of this paragraph.
                    </p>
                    <p>
                        You agree that all information you provide to register with or use the
                        Services or otherwise is governed by our Privacy Policy, and you consent to
                        all actions we take with respect to your information consistent with our
                        Privacy Policy.
                    </p>
                    <p>
                        You agree to keep your account information confidential and to not share
                        your account with others. You agree to notify us immediately of any
                        unauthorized access to your account or any other breach of security.
                    </p>
                    <p>
                        <strong>Payment Methods</strong>
                        <strong></strong>
                    </p>
                    <p>
                        In order to purchase a membership, you must pay by (1) credit card or (2)
                        PayPal ("<strong>Payment Method</strong>"). To pay by credit card, you must
                        provide the full credit card number, the name on the credit card, the
                        expiration date, the CVC number, and the billing address. The personal
                        information that you provide to us will be collected, stored, and processed
                        in accordance with our Privacy Policy. If you pay using PayPal, you agree
                        to PayPal's terms and agreements, available at
                        https://www.paypal.com/us/home.
                    </p>
                    <p>
                        All payment transactions made through the Website are processed by Stripe,
                        a service offered by Stripe, Inc., and your payments are processed by
                        Stripe in accordance with Stripe's terms and privacy policy, available on
                        Stripe, Inc.'s website, https://stripe.com/. By using the Services, you
                        agree to be bound by Stripe Inc.'s terms and privacy policy. By entering
                        your payment information, you confirm that the Payment Method being used is
                        yours or that you have been authorized by the owner of the Payment Method
                        to use it. All Payment Methods are subject to validation checks and
                        authorization by the issuer. If the credit or debit card issuer refuses to
                        authorize payment, we will not be responsible for any delay in your ability
                        to access and use the Services.
                    </p>
                    <p>
                        ChartOne does not store credit card or payment information. Payment
                        information is passed directly to Stripe and PayPal.
                        Please note that while we take reasonable care to keep the details of your
                        order and payment secure, in the absence of negligence on our part we are
                        not liable for any loss you may suffer if a third party gains unauthorized
                        access to any information that you provide.
                    </p>
                    <p>
                        <strong>Free Trials; Special Offers</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        Your access to the Services may begin with a free trial and/or offer. The
                        free trial and/or offer period of your membership<strong> </strong>lasts
                        for the period specified when you sign up. Free trials are for new members
                        only. We reserve the right, in our sole discretion, to determine your free
                        trial eligibility and to provide you with special offers.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>
                            At the end of any free trial or offer period, we will begin billing you
                            for the monthly membership fee unless you cancel prior to the end of
                            the free trial or offer period. You will not receive a notice from us
                            that your free trial or offer period has ended. We will continue to
                            bill your Payment Method on a monthly basis for your membership fee
                            until you cancel. For additional information, see "Membership
                            Autorenewals"
                        </strong>
                        <strong>above.</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>
                            By starting a free trial and providing or designating a Payment Method,
                            you authorize us to charge you a monthly membership fee at the
                            then-current rate.
                        </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong>Membership Autorenewals; Cancellations</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>A. Membership Autorenewals (Generally)</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>
                            Your membership will automatically renew monthly, and we will charge
                            your Payment Method on a monthly basis, until you cancel your
                            membership (see "Cancellations" below for instructions on how to cancel
                            your membership) or we terminate your membership. If you cancel your
                            membership, you will continue to have access to the Services through
                            the end of your membership period. If you started your membership with
                            a free trial or offer, you will be charged beginning at the expiration
                            of your free trial or offer period.
                        </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>
                            Unless you notify us before a charge to your Payment Method that you
                            want to cancel or do not want to automatically renew, you understand
                            and agree that your membership will automatically renew and you
                            authorize us, without notice to you (unless required by applicable law)
                            to collect the then-applicable membership price by charging the Payment
                            Method that we have on file for you.
                        </strong>
                        <strong>
                            If we cannot charge the Payment Method that we have on file for you, we
                            will contact you via email. We reserve the right to change the calendar
                            day that we bill you if your Payment Method cannot be charged.
                        </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>
                            B. Timing of Automatic Renewal Charges; When to Cancel to Avoid
                            Automatic Renewal Charges for the Following Month
                        </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong>
                            We automatically bill the membership renewal fee to your Payment Method
                            each month on the calendar day corresponding to the commencement of
                            your membership. If you signed up for a free trial, the calendar day
                            will be based on the date that your paying membership commences
                            following the expiration of your free trial period.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            If your membership began on a day that is not contained within a given
                            month, we may bill your Payment Method on a day in that month that we
                            deem appropriate in our sole discretion. For example, if you started
                            your membership on December 31, your Payment Method would next be
                            charged on January 31 and again on approximately February 28.
                        </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong>
                            In order to avoid charges for the following month's membership fees to
                            your Payment Method, you must cancel your membership at least 48 hours
                            prior to the date that your membership renews each month. For example,
                            if you began your membership on April 1, you must cancel on or before
                            April 28 in order to avoid paying membership fees for the following
                            month (in this example, May 1 through May 31).
                        </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>C. Cancellations</strong>
                        <strong></strong>
                    </p>
                    <p>
                        You may cancel your membership<strong> </strong>at any time by logging into
                        your account and selecting the "Cancel" option in your profile.
                    </p>
                    <p>
                        When you cancel a membership, you cancel only future charges associated
                        with your membership. You may cancel at any time, but the cancellation will
                        not become effective until the end of your current billing period and you
                        will cancel only future charges associated with your membership. You will
                        not receive a refund for the current billing cycle. For additional
                        information, please see "Membership<strong> </strong>Autorenewals
                        (Generally)" and "Timing of Automatic Renewal Charges; When to Cancel to
                        Avoid Automatic Renewal Charges for the Following Month" above.
                    </p>
                    <p>
                        Except in the case of certain promotions, you can change or cancel your
                        membership<strong> </strong>at any time. Memberships sold as part of a
                        promotion, subject to an annual commitment, or as an add-on may have
                        different cancellation or refund policies that will be made clear at the
                        time of purchase.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Membership Packages and Gifting</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <em> </em>
                    </p>
                    <p>
                        You may choose a membership<strong> </strong>package for six (6) months or
                        twelve (12) months and pay in advance for your membership.
                        <strong>
                            If you elect such a membership package, your membership will be
                            automatically renewed for the same membership package at the end of
                            your membership period.
                        </strong>
                        <strong>For additional information, see "Membership Autorenewals" </strong>
                        <strong>above. </strong>
                        These membership<strong> </strong>packages are nonrefundable once
                        purchased.<strong> </strong>
                    </p>
                    <p>
                        You may gift a twelve (12)-month membership<strong> </strong>to someone
                        else ("<strong>Gift Membership</strong>"). Gift Memberships<strong> </strong>will not automatically renew at the end of the membership    <strong> </strong>period. Please note that Gift Memberships cannot be
                        cancelled.
                    </p>
                    <p>
                        <strong>Pricing</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        We reserve the right to adjust pricing for the Services in any manner and
                        at any time in our sole discretion.
                    </p>
                    <p>
                        <strong>Refunds </strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        Payments are nonrefundable. No prorated refunds of any membership    <strong> </strong>fees paid will be issued upon any termination or
                        cancellation of a membership.
                    </p>
                    <p>
                        <strong>Clicks for Good </strong>
                        <strong></strong>
                    </p>
                    <p>
                        Clicks for Good is a program designed to enable users to give back while
                        they are giving to themselves. ChartOne is committed to donating money to
                        charitable organizations. At its sole discretion, ChartOne selects the
                        charitable organizations that will receive donations from ChartOne and may
                        revise its selection(s) at any time. ChartOne will in no event be liable
                        for any failure to give money to a particular charitable organization, nor
                        for a failure to give any particular amount.
                    </p>
                    <p>
                        <strong>Events: Tone Talks and Tone Live</strong>
                    </p>
                    <p>
                        As a user, you will participate in the ChartOne Events through (i) Tone
                        Talks, which are moderated, topic-focused discussions that are not driven
                        by experts, in which users are encouraged to share their expertise with
                        each other, and (ii) Tone Live, which is a live streaming interactive event
                        that gives users access to experts and the ability to ask questions of the
                        expert.
                    </p>
                    <p>
                        By participating in Tone Talks and/or Tone Live, you acknowledge and agree
                        that ChartOne has sole discretion to determine the topics of discussion and
                        the questions that the experts will receive and answer. ChartOne reserves
                        the right in its sole discretion to terminate the participation of any
                        users that it considers counterproductive, off-topic, or offensive, in its
                        sole discretion. ChartOne will not be liable for any failure to terminate
                        any participant in Tone Talks and/or Tone Live. Additionally, ChartOne
                        reserves the right in its sole discretion to terminate the membership    <strong> </strong>of any user that it deems to be an offender of ChartOne's
                        policies and/or Terms of Service.
                    </p>
                    <p>
                        By participating in Tone Talks and/or Tone Live, you acknowledge and agree
                        that ChartOne does not prescreen the topics of discussion and in no event
                        will be liable for anything that is discussed at Tone Talks and/or Tone
                        Live.
                    </p>
                    <p>
                        <strong>Information Provided Through the Services</strong>
                        <strong></strong>
                    </p>
                    <p>
                        The information provided through the Services is for informational purposes
                        only and is not a substitute for professional, financial, health, legal, or
                        other advice, nor a replacement for individual relationship between you and
                        a qualified professional. This information has been prepared to provide
                        information regarding topics related to lifestyle topics, including but not
                        limited to legal information, financial, relationship, and general and
                        specific health issues, including but not limited to mindfulness,
                        nutrition, and fitness.
                    </p>
                    <p>
                        By using the Services, you acknowledge and agree that (i) ChartOne and the
                        experts featured on ChartOne's website do not intend any of the information
                        provided through the Services to be used for self-diagnosis or treatment;
                        (ii) that ChartOne has not independently verified the credentials of
                        experts and that you have thus made any independent valuations or judgments
                        of experts on our Website before relying on their advice; (iii) you rely on
                        any advice at your own risk, and you are solely responsible for verifying
                        any information and for determining the suitability of any information
                        obtained through the Services; (iv) you waive any and all rights or claims
                        that you may have to obtain a refund and (v) ChartOne has no liability to
                        you for any reason for any advice or Services.
                    </p>
                    <p>
                        IF YOU HAVE ANY QUESTIONS OR CONCERNS ABOUT YOUR HEALTH AND BEFORE STARTING
                        OR STOPPING ANY TREATMENT OR ACTING UPON INFORMATION ACCESSIBLE THROUGH THE
                        SERVICES, YOU SHOULD CONTACT YOUR OWN PHYSICIAN OR HEALTH CARE PROVIDER.
                        ADDITIONALLY, IF YOU HAVE ANY QUESTIONS OR CONCERNS ABOUT ANY OF THE OTHER
                        TOPICS DISCUSSED THROUGH THE SERVICES, YOU SHOULD CONTACT A QUALIFIED
                        PROFESSIONAL TO DISCUSS YOUR PARTICULAR FACTS AND CIRCUMSTANCES BEFORE
                        ACTING UPON INFORMATION ACCESSIBLE THROUGH THE SERVICES.
                    </p>
                    <p>
                        ChartOne make no representations or warranties and expressly disclaims any
                        and all liability concerning any treatment or action based on the
                        information offered or provided through the Services. ChartOne does not
                        represent or warrant that any such information will meet your expectations
                        and does not make any representations or warranties with respect to the
                        quality of advice provided by experts, and is not responsible for the
                        quality of advice. By using the Services, you acknowledge and agree that
                        (i) ChartOne does not review or endorse any information or advice provided
                        through the Services, and does not have any liability to you with respect
                        to any information or advice provided through the services; (ii) ChartOne
                        does not verify the accuracy of information nor opinions provided by
                        experts; and (iii) while ChartOne researches and curates experts in order
                        to identify their appropriateness, ChartOne does not do background checks
                        on experts and does not verify their credentials, including but not limited
                        to educational degrees received, certifications and/or licenses. ChartOne
                        relies on the experts' representation of themselves on their websites,
                        social media accounts, and in published materials.
                    </p>
                    <p>
                        IF YOU HAVE SPECIFIC CONCERNS OR REQUIRE PROFESSIONAL ADVICE, YOU SHOULD
                        CONSULT WITH A QUALIFIED PROFESSIONAL. THESE SERVICES ARE NOT DESIGNED AS,
                        NOR SHOULD YOU USE THESE SERVICES AS, A SUBSTITUTE FOR ADVICE FROM A
                        QUALIFIED PROFESSIONAL.
                    </p>
                    <p>
                        If you have a dispute with another user or expert, you hereby release
                        ChartOne (and our officers, directors, agents, subsidiaries, joint ventures
                        and employees) from claims, demands and damages (actual and consequential)
                        of every kind and nature, known and unknown, arising out of or in any way
                        connected with such disputes, including damages for loss of profits,
                        goodwill, use, privacy or data. We reserve the right, but have no
                        obligation, to become involved in any way with these disputes. If you are a
                        California resident, you waive California Civil Code &#167;1542, which
                        says: "A general release does not extend to claims which the creditor does
                        not know or suspect to exist in his or her favor at the time of executing
                        the release, which if known by him or her must have materially affected his
                        settlement with the debtor." And, if you are not a California resident, you
                        waive any applicable state statutes of a similar effect.
                    </p>
                    <p>
                        <strong>Changes and Termination of Services</strong>
                    </p>
                    <p>
                        We are constantly changing and improving our Services. We reserve the right
                        to add or remove functionalities or features of the Services, and we may
                        suspend, stop, or delete an account or may suspend or stop the Services
                        altogether, including, for example, if you do not comply with these Terms
                        of Service or if we are investigating suspected misconduct or breach of any
                        applicable laws. You can stop using our Services at any time. We may also
                        stop providing Services to you, add or create new limits to our Services,
                        or restrict your access to all or a part of the Services at any time and
                        for any reason without notice or liability. We will not be liable if for
                        any reason all or any part of the Services are unavailable at any time or
                        for any period. The right to access and use the Services is revoked in
                        jurisdictions where it may be prohibited, if any.
                    </p>
                    <p>
                        <strong>Internet Connections; Mobile Access</strong>
                        <strong></strong>
                    </p>
                    <p>
                        You understand that ChartOne provides the Services over the Internet and
                        that such connections can be unpredictable, insecure, and unstable, such
                        that ChartOne cannot guarantee uninterrupted access to the Services.
                        ChartOne disclaims all liability in connection with any interruptions to
                        Service access, security incidents, or breaches arising from or
                        attributable to an Internet and/or data connection. You agree to waive any
                        and all claims against ChartOne in connection therewith.
                    </p>
                    <p>
                        To the extent that you access the Services through a mobile device, you
                        acknowledge and agree that your wireless service carrier's standard
                        charges, data rates and other fees may apply, and that all such charges and
                        fees will be your sole responsibility. You should check with your carrier
                        to find out what plans are available and how much they cost. In addition,
                        downloading, installing, or using certain mobile services may be prohibited
                        or restricted by your carrier, and not all mobile services may work with
                        all carriers or devices. Therefore, you should check with your carrier to
                        find out if the mobile services are available for your mobile device, and
                        what restrictions, if any, may be applicable to your use of such mobile
                        services.
                    </p>
                    <p>
                        By using the Services, you agree that we may communicate with you regarding
                        the Services by electronic means to your mobile device and that certain
                        information about your usage of the mobile services may be communicated to
                        us.
                    </p>
                    <p>
                        We may from time to time make updates to the Services. Such updates may
                        require your acceptance of new Terms of Service before you may continue to
                        use the Services.
                    </p>
                    <p>
                        <strong>Licenses Granted</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        ChartOne grants to you a revocable, non-transferable, nonexclusive, limited
                        and non-assignable license to access and use the Services in accordance
                        with these Terms of Service. ChartOne reserves all other rights in the
                        Services not expressly granted to you.
                    </p>
                    <p>
                        You grant ChartOne a worldwide, unlimited, irrevocable, royalty-free
                        license to publicly and privately use, publish, reproduce, display, copy,
                        edit, perform, create derivative works from, or otherwise make use of any
                        content you submit through the Services, including but not limited to any
                        videos, photos, graphics, sounds, music, audio transcripts of videos,
                        comments, messages, and other text that are viewable or accessible through
                        the Services ("<strong>Content</strong>"). You understand and acknowledge
                        that you are responsible for any Content you submit or contribute, and you,
                        not ChartOne, are fully responsible for such content, including its
                        legality, reliability, accuracy and appropriateness. We are not
                        responsible, or liable to any third party, for the content or accuracy of
                        any Content. We cannot guarantee the identity of any other users with whom
                        you may interact in the course of using the Services, nor the authenticity
                        of any information that experts may provide about themselves. You
                        acknowledge that all content accessed by you using the Services is at your
                        own risk and you will be solely responsible for any damage or loss to any
                        party resulting therefrom.
                    </p>
                    <p>
                        You grant ChartOne a worldwide, unlimited, irrevocable, royalty-free
                        license to publicly and privately use, distribute, modify, offer for sale
                        or exploit any (i) suggestions, ideas, criticism, or other type of feedback
                        you make relating to the Services and (ii) any topics of interest that you
                        select or other polling data that you provide through watching content
                        through the Services, with no obligation to pay you royalties or any other
                        compensation.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Conduct and Events Guidelines</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You may use the Services only for lawful purposes and in accordance with
                        these Terms of Service. Without limiting the generality of the foregoing,
                        you agree to use the Services in accordance with the provisions below:
                    </p>
                    <p>
                        &#8226; You will only use the Services in accordance with the laws of your
                        jurisdiction for personal, non-commercial purposes.
                    </p>
                    <p>
                        &#8226; You will be respectful and considerate of other users and will not
                        harass or threaten other users or violate the rights of any other party,
                        and you will do your part to make the Website a safe and supportive
                        community for all users.
                    </p>
                    <p>
                        &#8226; You will not impersonate someone else or misrepresent your
                        affiliation with someone else.
                    </p>
                    <p>
                        &#8226; You will register for the Services using accurate and current
                        information, and you will not impersonate or attempt to impersonate
                        ChartOne, a ChartOne employee, another user, an expert, or any other person
                        or entity (including, without limitation, by using e-mail addresses or
                        usernames associated with any of the foregoing).
                    </p>
                    <p>
                        &#8226; You will not post Content that infringes another's intellectual
                        property rights.
                    </p>
                    <p>
                        &#8226; You may not decompile, reverse engineer, or otherwise attempt to
                        obtain the source code of any content on the Services.
                    </p>
                    <p>
                        &#8226; You will independently verify the quality, relevance or accuracy of
                        any information posted on the Services by others.
                    </p>
                    <p>
                        &#8226; You will not use, store, copy, upload, display, post, reproduce,
                        modify, translate, republish, distribute, broadcast, transmit, create
                        derivative works from, display, license, sell or otherwise exploit any part
                        of the Services or content on the Services in any form whatsoever other
                        than as expressly permitted under these Terms of Service.
                    </p>
                    <p>
                        &#8226; You will not use contact information received through the Services
                        for phishing, spamming and other unsolicited communications or data
                        collection.
                    </p>
                    <p>
                        &#8226; You will not collect or store any personally identifiable
                        information from the Services from other users of the Services without
                        their express permission.
                    </p>
                    <p>
                        &#8226; You will not submit or post unsolicited promotional content,
                        advertising, political campaigns, contests, raffles or solicitations.
                    </p>
                    <p>
                        &#8226; You will not use the Services in a manner intended to damage,
                        disable, overburden or impair the Services or to disrupt or interfere with
                        another's use of the Services.
                    </p>
                    <p>
                        &#8226; You will not attempt to hack or otherwise gain unauthorized access
                        to the Services or accounts.
                    </p>
                    <p>
                        &#8226; You will not use high volume, automated, or electronic means to
                        access the Services (including without limitation robots, spiders, or
                        scripts).
                    </p>
                    <p>
                        &#8226; You will not affect the display of the Services through use of
                        framing, pop-ups or third-party ads.
                    </p>
                    <p>
                        &#8226; You will not transmit malware, software viruses, Trojan horses,
                        worms or any other malicious application to or through the Services.
                    </p>
                    <p>
                        &#8226; You will not threaten, dox, or otherwise harass other users or
                        experts.
                    </p>
                    <p>
                        &#8226; You will not submit or post information that is inaccurate, false,
                        fraudulent, or misleading, including submissions made under false
                        pretenses.
                    </p>
                    <p>
                        &#8226; You will not submit or post unlawful, harassing, libelous, abusive,
                        threatening, defamatory, vulgar, obscene, racist, harmful, inappropriate,
                        sexually explicit, or otherwise objectionable material of any kind,
                        including but not limited to posting any Content that promotes
                        discrimination, bigotry, racism, hatred, harassment or harm against any
                        individual or group; is violent or threatening or promotes violence or
                        actions that are threatening to any person or entity; and/or promotes
                        illegal or harmful activities or substances.
                    </p>
                    <p>
                        &#8226; You will not use any meta tags or other hidden text or metadata
                        utilizing a ChartOne trademark, logo URL or product name without ChartOne's
                        express written consent.
                    </p>
                    <p>
                        &#8226; You will not forge any TCP/IP packet header or any part of the
                        header information in any email or newsgroup posting, or in any way use the
                        Services or Content to send altered, deceptive or false source-identifying
                        information.
                    </p>
                    <p>
                        &#8226; You will not act in a manner that violates these Terms of Service.
                    </p>
                    <p>
                        &#8226; You will comply with applicable local, state, national or
                        international laws, statutes, ordinances, rules, regulations or ethical
                        codes governing your jurisdiction.
                    </p>
                    <p>
                        &#8226; You will notify us immediately of any content of the Services that
                        violates these Terms of Service.
                    </p>
                    <p>
                        We have the right to: (i) remove or refuse to post any Content for any or
                        no reason in our sole discretion; (ii) take any action with respect to any
                        Content that we deem necessary or appropriate in our sole discretion,
                        including if we believe that such Content violates these Terms of Service,
                        infringes any intellectual property right or other right of any person or
                        entity, threatens the personal safety of other users, experts, or the
                        public or could create liability for ChartOne; (iii) disclose your identity
                        or other information about you to any third party who claims that material
                        posted by you violates their rights, including their intellectual property
                        rights or their right to privacy; (iv) take appropriate legal action,
                        including without limitation, referral to law enforcement, for any illegal
                        or unauthorized use of the Services; and (v) terminate or suspend your
                        access to all or part of the Services for any or no reason, including
                        without limitation, any violation of these Terms of Service.
                    </p>
                    <p>
                        YOU WAIVE AND HOLD HARMLESS CHARTONE AND ITS AFFILIATES, LICENSEES AND
                        SERVICE PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY SUCH
                        PARTIES DURING OR AS A RESULT OF ITS INVESTIGATIONS AND FROM ANY ACTIONS
                        TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY SUCH PARTIES OR LAW ENFORCEMENT
                        AUTHORITIES.
                    </p>
                    <p>
                        We have no liability or responsibility to anyone for performance or
                        nonperformance of the activities described in this section.
                    </p>
                    <p>
                        <strong>Proprietary Rights</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        The Services and all past, present and future content of the Services,
                        including all software, hardware and technology used to provide the
                        Services (including our proprietary code and third-party software), user
                        interfaces, materials displayed or performed on the Services, such as text,
                        graphics, articles, photographs, images, illustrations and the design,
                        structure, sequence and "look and feel" of the Services, and all other
                        intellectual property, including all trademarks, service marks, logos, or
                        any other trade name, trademarks, service marks and other distinctive or
                        proprietary brand features of ChartOne, are (i) owned by ChartOne, its
                        licensors or other providers of such material, (ii) protected by United
                        States and international copyright, trademark, patent, trade secret and
                        other intellectual property or proprietary rights laws, (iii) are intended
                        solely for the personal, non-commercial use of our users and experts, and
                        (iv) may only be used in accordance with these Terms of Service.
                    </p>
                    <p>
                        Using our Services does not give you ownership of any intellectual property
                        rights in the Services or any content on the Services. You may not use
                        content from the Services, including Content, unless you obtain permission
                        from ChartOne and the expert who generated the content, if different from
                        ChartOne, or are otherwise permitted by law. These Terms of Service do not
                        grant you the right to use any of ChartOne's technology or intellectual
                        property. You may not remove, obscure, or alter any copyright or other
                        legal notices displayed in or along with the Services.
                    </p>
                    <p>
                        No right, title or interest in or to the Services or any content on the
                        Services is transferred to you, and all rights not expressly granted are
                        reserved by ChartOne. Any use of the Services not expressly permitted by
                        these Terms of Service is a breach of these Terms and may violate
                        copyright, trademark and other laws.
                    </p>
                    <p>
                        <strong>Claims of Copyright Infringement</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        If you believe that your copyrighted work has been unlawfully copied and is
                        accessible on the Services in a way that constitutes copyright
                        infringement, please send a notice of copyright infringement to:
                    </p>
                    <p>
                        ChartOne Media LLC
                    </p>
                    <p>
                        P.O. Box 356
                    </p>
                    <p>
                        Oyster Bay, NY 11771
                    </p>
                    <p>
                        Phone: (516) 900-1000
                    </p>
                    <p>
                        Email: info@tonenetworks.com
                    </p>
                    <p>
                        The notice should include:
                    </p>
                    <p>
                        &#8226; Your full name and electronic or physical signature.
                    </p>
                    <p>
                        &#8226; Your mailing address, phone number and email address (at which you
                        can be contacted by us or the alleged infringer).
                    </p>
                    <p>
                        &#8226; A statement that you are the owner, or are authorized to act on
                        behalf of the owner, of the copyright that is allegedly infringed, and that
                        the information in your notice is accurate.
                    </p>
                    <p>
                        &#8226; A statement that you have a good faith belief that the disputed use
                        of the copyrighted materials is not authorized by the copyright owner, its
                        agent or by law, such as fair use.
                    </p>
                    <p>
                        &#8226; A description of the copyrighted work(s) that you claim has been
                        infringed.
                    </p>
                    <p>
                        &#8226; A description of the location of the copyrighted materials on the
                        Services.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Electronic Delivery Statement and Your Consent</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You agree to receive legal notices and other information concerning
                        ChartOne or the Services electronically, including notice to any email
                        address that you may provide.
                    </p>
                    <p>
                        <strong>Term and Termination</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        These Terms of Service will remain in effect until terminated by you or
                        ChartOne. We reserve the right to terminate or change the Services or your
                        access to the Services, without notice, at any time and for any reason,
                        including your violation of these Terms of Service or for business reasons.
                        The disclaimer of warranties, limitation of liability, jurisdictional,
                        limitation of time to file claims, indemnification and arbitration
                        provisions survive any termination.
                    </p>
                    <p>
                        You agree that ChartOne may, for any reason and without notice to you,
                        immediately terminate or otherwise restrict your access to the Services.
                        ChartOne has no obligation to maintain, store, or transfer your information
                        or data that you have posted on or uploaded to the Services.
                    </p>
                    <p>
                        <strong>Disclaimer of Representations and Warranties</strong>
                        <strong></strong>
                    </p>
                    <p>
                        THE SERVICES AND ANY ASSOCIATED CONTENT ARE PROVIDED ON AN "AS IS" AND "AS
                        AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR
                        IMPLIED. NEITHER CHARTONE NOR ANY PERSON ASSOCIATED WITH CHARTONE MAKES ANY
                        REPRESENTATION OR WARRANTY WITH RESPECT TO THE COMPLETENESS, SECURITY,
                        RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE SERVICES OR ANY
                        ASSOCIATED CONTENT. WITHOUT LIMITING THE FOREGOING, NEITHER CHARTONE NOR
                        ANYONE ASSOCIATED WITH CHARTONE REPRESENTS OR WARRANTS THAT THE SERVICES OR
                        ANY ASSOCIATED CONTENT WILL BE ACCURATE, RELIABLE, ERROR-FREE, UPDATED OR
                        UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT THE SERVICES ARE FREE
                        OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SERVICES WILL OTHERWISE
                        MEET YOUR NEEDS OR EXPECTATIONS.
                    </p>
                    <p>
                        CHARTONE HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
                        IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY
                        WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR
                        PURPOSE.
                    </p>
                    <p>
                        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
                        LIMITED UNDER APPLICABLE LAW.
                    </p>
                    <p>
                        <strong>Limitation of Liability</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        YOUR USE OF THE SERVICES AND ANY CONTENT ON THE SERVICES IS AT YOUR SOLE
                        RISK AND DISCRETION. You may not assert claims for money damages arising
                        from the Services or any associated content against ChartOne, its
                        affiliates, licensors or service providers, or our respective employees,
                        contractors, officers, directors and agents. ChartOne, its affiliates,
                        licensors and service providers, and its respective employees, contractors,
                        officers, directors and agents shall not be liable for any direct,
                        indirect, special, incidental, consequential or punitive damages, including
                        but not limited to personal injury, pain and suffering, emotional distress,
                        or loss of revenue, profits, goodwill or data, whether caused by tort
                        (including negligence), breach of contract or otherwise, even if ChartOne
                        knew or should have known of the possibility of such damages, arising out
                        of or in connection with (i) your use, or inability to use, the Services or
                        any associated content or Content, (ii) any interaction with any third
                        party through or in connection with the Services, including experts and
                        other users, (iii) any information offered or provided within or through
                        the Services, or (iii) any other matter relating to the Services. In no
                        event shall ChartOne, its affiliates, licensors or service providers, or
                        its respective employees, contractors, officers, directors and agents be
                        liable to you in the aggregate (for all potential claims by you) for any
                        damages incurred in excess of one hundred dollars ($100). Because some
                        states or jurisdictions do not allow the exclusion or the limitation of
                        liability for consequential or incidental damages, in such states or
                        jurisdictions, ChartOne's liability shall be limited to the extent
                        permitted by law.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Indemnification</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You are solely legally liable if your use or misuse of the Services or any
                        associated content causes damage to the Services, to you, or to someone or
                        something else. You agree to defend, indemnify, and hold harmless ChartOne,
                        its affiliates, licensors and service providers, and its respective
                        employees, contractors, officers, directors and agents from and against all
                        liabilities, claims, damages, judgment, awards, losses, costs, expenses,
                        fines or fees (including attorney's fees and investigation costs), that
                        arise from or relate to your use or misuse of the Services, violation of
                        these Terms of Service or violation of a third party's rights. ChartOne
                        reserves the right, at ChartOne's own expense, to assume the exclusive
                        defense and control of any matter otherwise subject to indemnification by
                        you, in which event you agree to cooperate with ChartOne in asserting any
                        available defenses.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Limitation on Time to File Claims</strong>
                        <strong></strong>
                    </p>
                    <p>
                        Any cause of action or claim you may have arising out of or relating to
                        these Terms of Service or the Services must be commenced within one (1)
                        year after the cause of action accrues, otherwise, such cause of action is
                        permanently barred.
                    </p>
                    <p>
                        <strong>Choice of Law and Jurisdiction</strong>
                        <strong></strong>
                    </p>
                    <p>
                        You agree that the laws of the State of New York and U.S. federal law
                        govern these Terms of Service, your use of the Services, and any claim or
                        dispute that you may have against ChartOne, without regard to New York's
                        conflict of laws rules. You consent to the personal and exclusive
                        jurisdiction of the federal and state courts of New York, New York. The
                        United Nations Convention on Contracts for the International Sale of Goods
                        does not apply to this Agreement.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Binding Arbitration</strong>
                        <strong></strong>
                    </p>
                    <p>
                        In the rare event you have a dispute with ChartOne, we encourage you to
                        contact us immediately so we can work together toward a satisfactory
                        resolution. If we cannot come to a resolution, you agree that any claims,
                        disputes, demands, counts, controversies, or causes of action between you
                        and ChartOne arising out of or relating to these Terms of Service, the
                        Services, including the enforceability of these Terms of Service or our
                        Privacy Policy or information practices will be finally and exclusively
                        resolved by binding arbitration on an individual basis only (except as
                        stated below). The arbitrator may not consolidate more than one person's
                        claims, and may not otherwise preside over any form of any class or
                        representative proceeding.
                    </p>
                    <p>
                        You understand that you are waiving your right to have your claims heard in
                        court by a judge or jury. An arbitration award is as enforceable as a court
                        order and is subject to only limited review by a judge. You also understand
                        and agree that this arbitration provision prevents you from participating
                        as a plaintiff or as a class member in any purported class action or
                        representative proceeding.
                    </p>
                    <p>
                        Arbitration will be subject to the Federal Arbitration Act, and shall be
                        commenced and conducted by the American Arbitration Association ("    <strong>AAA</strong>") under the Commercial Arbitration Rules and the
                        Supplementary Procedures for Consumer Related Disputes, as amended by this
                        provision, by one arbitrator that is acceptable to both parties. You can
                        find out more AAA and how to file an arbitration claim at www.adr.org or by
                        calling 800-778-7879.
                    </p>
                    <p>
                        Your arbitration fees and your share of arbitrator compensation shall be
                        governed by the AAA rules and, where appropriate, limited by the AAA
                        Consumer Rules. In the event you are able to demonstrate that the costs of
                        arbitration will be prohibitive as compared to the costs of litigation,
                        ChartOne will pay as much of your filing, administrative, and arbitrator
                        fees in connection with the arbitration as the arbitrator deems necessary
                        to prevent arbitration from being cost-prohibitive. In such case, we will
                        make arrangements to pay all necessary fees directly to the AAA. If the
                        arbitrator determines the claim(s) you assert in the arbitration are
                        frivolous, you agree to reimburse ChartOne for all fees associated with the
                        arbitration paid by ChartOne on your behalf, which you otherwise would be
                        obligated to pay under the AAA's rules.
                    </p>
                    <p>
                        The arbitration will be conducted through written submission, unless the
                        arbitrator determines that a telephonic hearing is required. Except as
                        otherwise provided in these Terms of Service, you and ChartOne may litigate
                        in court to compel arbitration, stay proceedings pending arbitration, or to
                        confirm, modify, vacate or enter judgment on the award entered by the
                        arbitrator. In the event this arbitration provision is held unenforceable
                        by a court, or in the event AAA refuses to arbitrate the dispute, all
                        controversies, disputes, demands, counts, claims, or causes of action
                        between you and ChartOne shall be exclusively brought in the state or
                        federal courts of New York, New York.
                    </p>
                    <p>
                        Despite this provision, you may file a claim in a small claims court that
                        has jurisdiction to hear the matter.
                    </p>
                    <p>
                        <strong>Severability and Integration</strong>
                        <strong></strong>
                    </p>
                    <p>
                        These Terms of Service and any supplemental terms, policies, rules and
                        guidelines posted on the Services constitute the entire agreement between
                        you and ChartOne. If any part of the Terms of Service is held invalid or
                        unenforceable, that portion shall be construed in a manner consistent with
                        applicable law to reflect, as nearly as possible, the original intentions
                        of the parties, and the remaining portions shall remain in full force and
                        effect.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>General Provisions</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You may not assign these Terms of Service without ChartOne's prior written
                        approval. ChartOne may assign these Terms without your consent to: (i) a
                        subsidiary or affiliate; (ii) an acquirer of ChartOne's business or assets;
                        or (iii) a successor by merger. Any purported assignment in violation of
                        this section shall be void. No joint venture, partnership, employment, or
                        agency relationship exists between you and ChartOne as a result of these
                        Terms of Service or your use of the Services. Our failure to enforce any
                        right or provision in these Terms of Service shall not constitute a waiver
                        of such right or provision unless acknowledged and agreed to by ChartOne in
                        writing.
                    </p>
                    <p>
                        <strong>Contact Information</strong>
                        <strong></strong>
                    </p>
                    <p>
                        The Services are operated by ChartOne LLC. All feedback, comments, requests
                        for technical support and other communications relating to the Services
                        should be directed to us at:
                    </p>
                    <p>
                        ChartOne Media LLC
                    </p>
                    <p>
                        P.O. Box 356
                    </p>
                    <p>
                        Oyster Bay, NY 11771
                    </p>
                    <p>
                        Phone: (516) 900-1000
                    </p>
                    <p>
                        Email: info@tonenetworks.com
                    </p>
                </div>
            </div>
            <div class="row" :class="{ hidden: !isHidden() }">
                <div class="col-md-12">
                    <div class="main-content">
                        <h3 class="heading" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">Terms of Service</h3>
                    </div>
                </div>
                <div class="col-md-12 text-left">
                    <p>
                        Last Modified: April 24, 2025
                    </p>
                    <p>
                        These Terms of Service ("<strong>Terms of Service</strong>") govern your
                        access to and use of the website located at <a href="https://tonenetworks.com" target="_blank">https://tonenetworks.com
                    </a>
                        (the "<strong>Website</strong>"), including any content, functionality and
                        services offered on or through the Website, memberships, and any of our
                        other products or services (collectively referred to as the "    <strong>Services</strong>"). The Website is owned and operated by ChartOne
                        Media LLC, a Delaware limited liability company ("<strong>ChartOne</strong>
                        ", "<strong>we</strong>" or "<strong>us</strong>").
                    </p>
                    <p>
                        Please read the Terms of Service carefully before using the Services
                        because they contain provisions that affect your rights and obligations,
                        including a mandatory arbitration provision and a waiver of your right to
                        participate in a class action. By using the Services, you accept and agree
                        to be bound and abide by these Terms of Service and our Privacy Policy,
                        found at
                        <a  href="https://tonenetworks.com/privacypolicy" target="_new">
                            https://tonenetworks.com/privacypolicy
                        </a>
                        ("<strong>Privacy Policy</strong>"), which are incorporated herein by
                        reference. If you do not want to agree to these Terms of Service or the
                        Privacy Policy, you must not access or use the Services.
                    </p>
                    <p>
                        The Services are offered and available to individuals who are 18 years of
                        age or older. By using the Services, you represent and warrant to ChartOne
                        that you are 18 years of age or older and are otherwise capable of forming
                        a legally binding contract with ChartOne, and that your use of the Services
                        is consistent with our Terms of Service, our Privacy Policy, and all
                        applicable law. If you do not meet these requirements, you must not access
                        or use the Services.
                    </p>
                    <p>
                        You acknowledge and confirm that (i) you have read and understand all of
                        the terms, conditions, policies, provisions, disclosures and disclaimers
                        contained herein, (ii) these Terms of Service have the same force and
                        effect as a signed agreement, and (iii) you expressly accept and agree to
                        be bound by the terms hereof.
                    </p>
                    <p>
                        <strong>Changes to these Terms of Service</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        We may modify these Terms of Service at any time in our sole discretion. We
                        will post notice of changes to these Terms of Service on this page. Changes
                        will not apply retroactively and will only become effective when (i) you
                        use the Services after you know about the change, or (ii) thirty (30) days
                        after they are posted, whichever is sooner. However, changes addressing new
                        functions for a Service or changes made for legal reasons will be effective
                        immediately. We will also update the Last Modified Date at the top of these
                        Terms of Service accordingly. Your continued use of the Services after the
                        Last Modified Date signifies your consent to the modified Terms of Service.
                        You are expected to check this page frequently so you are aware of any
                        changes, as they are binding on you. If the modified Terms of Service are
                        not acceptable to you, you should not access or use the Services after the
                        Last Modified Date and may cancel your membership (see "Cancellations"
                        below).
                    </p>
                    <p>
                        <strong>Data Privacy and Personal Information</strong>
                        <strong></strong>
                    </p>
                    <p>
                        By agreeing to these Terms of Service, you also consent to our Privacy
                        Policy, which is incorporated by reference into these Terms of Service. If
                        you live outside the United States, by agreeing to these Terms of Service
                        you consent to the transfer and processing of your personal information in
                        the United States in accordance with the Privacy Policy and U.S. law.
                    </p>
                    <p>
                        You should not submit or upload personal information or any other
                        information about yourself or others that you are not comfortable
                        disclosing to the general public. This information will be viewable by
                        other users of the Services, may be searchable on indexing websites such as
                        Google, and may be disclosed to third parties under certain circumstances
                        as provided in our Privacy Policy.
                    </p>
                    <p>
                        By agreeing to these Terms of Service and our Privacy Policy, you
                        acknowledge and agree that we have the right to display any or all of the
                        information on your profile in our marketing materials and on our Website
                        without obtaining your permission.
                    </p>
                    <p>
                        <strong>International Users</strong>
                        <strong></strong>
                    </p>
                    <p>
                        ChartOne and the Services are operated from within the United States. If
                        you access the Services from a location outside the United States, you are
                        responsible for compliance with the laws of that jurisdiction regarding
                        online conduct and acceptable content. ChartOne makes no claim that the
                        content of the Services may be utilized, accessed or appropriate outside
                        the United States. You must not access or use the Services from a territory
                        that is embargoed by the United States or from which it is illegal to
                        receive products, services, or software from the United States.
                    </p>
                    <p>
                        <strong>Third Party Links</strong>
                        <strong></strong>
                    </p>
                    <p>
                        The Services may link to independent third-party websites or social media
                        widgets. Such hyperlinks are provided for your reference and convenience
                        only. ChartOne is not liable for the availability or accuracy of such
                        third-party sources, and you assume all risk in using them. When you link
                        to them, these third-party sites or services may place cookies and other
                        tracking technologies on your computer and may have different rules for
                        using or sharing any personal information you submit to them. By using such
                        third-party sources, sites, and/or sources, you agree to be bound by the
                        terms, privacy policy, and other policies of such third-parties. We
                        encourage you to read their privacy policies before submitting your
                        personal information.
                    </p>
                    <p>
                        When you access third party websites or interact or communicate with third
                        parties through the Services, you do so at your own risk. ChartOne is not
                        responsible for the actions, content, information, data, practices,
                        policies or opinions of any third parties. You are solely responsible for
                        your interactions with third parties and you should make whatever
                        investigation you feel necessary or appropriate before proceeding with any
                        online or offline interaction with any other person.
                    </p>
                    <p>
                        If you have a dispute with one more third party websites or third parties,
                        you hereby release us (and our officers, directors, agents, subsidiaries,
                        joint ventures and employees) from claims, demands and damages (actual and
                        consequential) of every kind and nature, known and unknown, arising out of
                        or in any way connected with such disputes, including damages for loss of
                        profits, goodwill, use, privacy or data. We reserve the right, but have no
                        obligation, to become involved in any way with these disputes. If you are a
                        California resident, you waive California Civil Code &#167;1542, which
                        says: "A general release does not extend to claims which the creditor does
                        not know or suspect to exist in his or her favor at the time of executing
                        the release, which if known by him or her must have materially affected his
                        settlement with the debtor." And, if you are not a California resident, you
                        waive any applicable state statutes of a similar effect.
                    </p>
                    <p>
                        <strong>Registration</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        Using the Services requires you to create an account and accept our Terms
                        of Service. To create an account, you must provide your name and email address.
                        You may also select one or more areas of interest.
                    </p>
                    <p>
                        By registering, you represent and warrant: (i) that all of the information
                        that you provide, including any social media profiles and other links that
                        you choose to add to your profile, is correct, current, and complete; (ii)
                        that you have created an account for yourself and have not misrepresented
                        your identity or created a false identity; and (iii) that you have not
                        registered for any illegal purpose, to facilitate any illegal topic, or
                        otherwise for the purpose of providing any illegal information. If you
                        believe that your identity or someone else's identity has been
                        misrepresented, please contact us immediately. You may also report other
                        users who you believe to be in breach of this paragraph.
                    </p>
                    <p>
                        You agree that all information you provide to register with or use the
                        Services or otherwise is governed by our Privacy Policy, and you consent to
                        all actions we take with respect to your information consistent with our
                        Privacy Policy.
                    </p>
                    <p>
                        You agree to keep your account information confidential and to not share
                        your account with others. You agree to notify us immediately of any
                        unauthorized access to your account or any other breach of security.
                    </p>
                    <p>
                        <strong>Events: Tone Talks and Tone Live</strong>
                    </p>
                    <p>
                        As a user, you will participate in the ChartOne Events through (i) Tone
                        Talks, which are moderated, topic-focused discussions that are not driven
                        by experts, in which users are encouraged to share their expertise with
                        each other, and (ii) Tone Live, which is a live streaming interactive event
                        that gives users access to experts and the ability to ask questions of the
                        expert.
                    </p>
                    <p>
                        By participating in Tone Talks and/or Tone Live, you acknowledge and agree
                        that ChartOne has sole discretion to determine the topics of discussion and
                        the questions that the experts will receive and answer. ChartOne reserves
                        the right in its sole discretion to terminate the participation of any
                        users that it considers counterproductive, off-topic, or offensive, in its
                        sole discretion. ChartOne will not be liable for any failure to terminate
                        any participant in Tone Talks and/or Tone Live. Additionally, ChartOne
                        reserves the right in its sole discretion to terminate the membership    <strong> </strong>of any user that it deems to be an offender of ChartOne's
                        policies and/or Terms of Service.
                    </p>
                    <p>
                        By participating in Tone Talks and/or Tone Live, you acknowledge and agree
                        that ChartOne does not prescreen the topics of discussion and in no event
                        will be liable for anything that is discussed at Tone Talks and/or Tone
                        Live.
                    </p>
                    <p>
                        <strong>Information Provided Through the Services</strong>
                        <strong></strong>
                    </p>
                    <p>
                        The information provided through the Services is for informational purposes
                        only and is not a substitute for professional, financial, health, legal, or
                        other advice, nor a replacement for individual relationship between you and
                        a qualified professional. This information has been prepared to provide
                        information regarding topics related to lifestyle topics, including but not
                        limited to legal information, financial, relationship, and general and
                        specific health issues, including but not limited to mindfulness,
                        nutrition, and fitness.
                    </p>
                    <p>
                        By using the Services, you acknowledge and agree that (i) ChartOne and the
                        experts featured on ChartOne's website do not intend any of the information
                        provided through the Services to be used for self-diagnosis or treatment;
                        (ii) that ChartOne has not independently verified the credentials of
                        experts and that you have thus made any independent valuations or judgments
                        of experts on our Website before relying on their advice; (iii) you rely on
                        any advice at your own risk, and you are solely responsible for verifying
                        any information and for determining the suitability of any information
                        obtained through the Services; (iv) you waive any and all rights or claims
                        that you may have to obtain a refund and (v) ChartOne has no liability to
                        you for any reason for any advice or Services.
                    </p>
                    <p>
                        IF YOU HAVE ANY QUESTIONS OR CONCERNS ABOUT YOUR HEALTH AND BEFORE STARTING
                        OR STOPPING ANY TREATMENT OR ACTING UPON INFORMATION ACCESSIBLE THROUGH THE
                        SERVICES, YOU SHOULD CONTACT YOUR OWN PHYSICIAN OR HEALTH CARE PROVIDER.
                        ADDITIONALLY, IF YOU HAVE ANY QUESTIONS OR CONCERNS ABOUT ANY OF THE OTHER
                        TOPICS DISCUSSED THROUGH THE SERVICES, YOU SHOULD CONTACT A QUALIFIED
                        PROFESSIONAL TO DISCUSS YOUR PARTICULAR FACTS AND CIRCUMSTANCES BEFORE
                        ACTING UPON INFORMATION ACCESSIBLE THROUGH THE SERVICES.
                    </p>
                    <p>
                        ChartOne makes no representations or warranties and expressly disclaims any
                        and all liability concerning any treatment or action based on the
                        information offered or provided through the Services. ChartOne does not
                        represent or warrant that any such information will meet your expectations
                        and does not make any representations or warranties with respect to the
                        quality of advice provided by experts, and is not responsible for the
                        quality of advice. By using the Services, you acknowledge and agree that
                        (i) ChartOne does not review or endorse any information or advice provided
                        through the Services, and does not have any liability to you with respect
                        to any information or advice provided through the services; (ii) ChartOne
                        does not verify the accuracy of information nor opinions provided by
                        experts; and (iii) while ChartOne researches and curates experts in order
                        to identify their appropriateness, ChartOne does not do background checks
                        on experts and does not verify their credentials, including but not limited
                        to educational degrees received, certifications and/or licenses. ChartOne
                        relies on the experts' representation of themselves on their websites,
                        social media accounts, and in published materials.
                    </p>
                    <p>
                        IF YOU HAVE SPECIFIC CONCERNS OR REQUIRE PROFESSIONAL ADVICE, YOU SHOULD
                        CONSULT WITH A QUALIFIED PROFESSIONAL. THESE SERVICES ARE NOT DESIGNED AS,
                        NOR SHOULD YOU USE THESE SERVICES AS, A SUBSTITUTE FOR ADVICE FROM A
                        QUALIFIED PROFESSIONAL.
                    </p>
                    <p>
                        If you have a dispute with another user or expert, you hereby release
                        ChartOne (and our officers, directors, agents, subsidiaries, joint ventures
                        and employees) from claims, demands and damages (actual and consequential)
                        of every kind and nature, known and unknown, arising out of or in any way
                        connected with such disputes, including damages for loss of profits,
                        goodwill, use, privacy or data. We reserve the right, but have no
                        obligation, to become involved in any way with these disputes. If you are a
                        California resident, you waive California Civil Code &#167;1542, which
                        says: "A general release does not extend to claims which the creditor does
                        not know or suspect to exist in his or her favor at the time of executing
                        the release, which if known by him or her must have materially affected his
                        settlement with the debtor." And, if you are not a California resident, you
                        waive any applicable state statutes of a similar effect.
                    </p>
                    <p>
                        <strong>Changes and Termination of Services</strong>
                    </p>
                    <p>
                        We are constantly changing and improving our Services. We reserve the right
                        to add or remove functionalities or features of the Services, and we may
                        suspend, stop, or delete an account or may suspend or stop the Services
                        altogether, including, for example, if you do not comply with these Terms
                        of Service or if we are investigating suspected misconduct or breach of any
                        applicable laws. You can stop using our Services at any time. We may also
                        stop providing Services to you, add or create new limits to our Services,
                        or restrict your access to all or a part of the Services at any time and
                        for any reason without notice or liability. We will not be liable if for
                        any reason all or any part of the Services are unavailable at any time or
                        for any period. The right to access and use the Services is revoked in
                        jurisdictions where it may be prohibited, if any.
                    </p>
                    <p>
                        <strong>Internet Connections; Mobile Access</strong>
                        <strong></strong>
                    </p>
                    <p>
                        You understand that ChartOne provides the Services over the Internet and
                        that such connections can be unpredictable, insecure, and unstable, such
                        that ChartOne cannot guarantee uninterrupted access to the Services.
                        ChartOne disclaims all liability in connection with any interruptions to
                        Service access, security incidents, or breaches arising from or
                        attributable to an Internet and/or data connection. You agree to waive any
                        and all claims against ChartOne in connection therewith.
                    </p>
                    <p>
                        To the extent that you access the Services through a mobile device, you
                        acknowledge and agree that your wireless service carrier's standard
                        charges, data rates and other fees may apply, and that all such charges and
                        fees will be your sole responsibility. You should check with your carrier
                        to find out what plans are available and how much they cost. In addition,
                        downloading, installing, or using certain mobile services may be prohibited
                        or restricted by your carrier, and not all mobile services may work with
                        all carriers or devices. Therefore, you should check with your carrier to
                        find out if the mobile services are available for your mobile device, and
                        what restrictions, if any, may be applicable to your use of such mobile
                        services.
                    </p>
                    <p>
                        By using the Services, you agree that we may communicate with you regarding
                        the Services by electronic means to your mobile device and that certain
                        information about your usage of the mobile services may be communicated to
                        us.
                    </p>
                    <p>
                        We may from time to time make updates to the Services. Such updates may
                        require your acceptance of new Terms of Service before you may continue to
                        use the Services.
                    </p>
                    <p>
                        <strong>Licenses Granted</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        ChartOne grants to you a revocable, non-transferable, nonexclusive, limited
                        and non-assignable license to access and use the Services in accordance
                        with these Terms of Service. ChartOne reserves all other rights in the
                        Services not expressly granted to you.
                    </p>
                    <p>
                        You grant ChartOne a worldwide, unlimited, irrevocable, royalty-free
                        license to publicly and privately use, publish, reproduce, display, copy,
                        edit, perform, create derivative works from, or otherwise make use of any
                        content you submit through the Services, including but not limited to any
                        videos, photos, graphics, sounds, music, audio transcripts of videos,
                        comments, messages, and other text that are viewable or accessible through
                        the Services ("<strong>Content</strong>"). You understand and acknowledge
                        that you are responsible for any Content you submit or contribute, and you,
                        not ChartOne, are fully responsible for such content, including its
                        legality, reliability, accuracy and appropriateness. We are not
                        responsible, or liable to any third party, for the content or accuracy of
                        any Content. We cannot guarantee the identity of any other users with whom
                        you may interact in the course of using the Services, nor the authenticity
                        of any information that experts may provide about themselves. You
                        acknowledge that all content accessed by you using the Services is at your
                        own risk and you will be solely responsible for any damage or loss to any
                        party resulting therefrom.
                    </p>
                    <p>
                        You grant ChartOne a worldwide, unlimited, irrevocable, royalty-free
                        license to publicly and privately use, distribute, modify, offer for sale
                        or exploit any (i) suggestions, ideas, criticism, or other type of feedback
                        you make relating to the Services and (ii) any topics of interest that you
                        select or other polling data that you provide through watching content
                        through the Services, with no obligation to pay you royalties or any other
                        compensation.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Conduct and Events Guidelines</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You may use the Services only for lawful purposes and in accordance with
                        these Terms of Service. Without limiting the generality of the foregoing,
                        you agree to use the Services in accordance with the provisions below:
                    </p>
                    <p>
                        &#8226; You will only use the Services in accordance with the laws of your
                        jurisdiction for personal, non-commercial purposes.
                    </p>
                    <p>
                        &#8226; You will be respectful and considerate of other users and will not
                        harass or threaten other users or violate the rights of any other party,
                        and you will do your part to make the Website a safe and supportive
                        community for all users.
                    </p>
                    <p>
                        &#8226; You will not impersonate someone else or misrepresent your
                        affiliation with someone else.
                    </p>
                    <p>
                        &#8226; You will register for the Services using accurate and current
                        information, and you will not impersonate or attempt to impersonate
                        ChartOne, a ChartOne employee, another user, an expert, or any other person
                        or entity (including, without limitation, by using e-mail addresses or
                        usernames associated with any of the foregoing).
                    </p>
                    <p>
                        &#8226; You will not post Content that infringes another's intellectual
                        property rights.
                    </p>
                    <p>
                        &#8226; You may not decompile, reverse engineer, or otherwise attempt to
                        obtain the source code of any content on the Services.
                    </p>
                    <p>
                        &#8226; You will independently verify the quality, relevance or accuracy of
                        any information posted on the Services by others.
                    </p>
                    <p>
                        &#8226; You will not use, store, copy, upload, display, post, reproduce,
                        modify, translate, republish, distribute, broadcast, transmit, create
                        derivative works from, display, license, sell or otherwise exploit any part
                        of the Services or content on the Services in any form whatsoever other
                        than as expressly permitted under these Terms of Service.
                    </p>
                    <p>
                        &#8226; You will not use contact information received through the Services
                        for phishing, spamming and other unsolicited communications or data
                        collection.
                    </p>
                    <p>
                        &#8226; You will not collect or store any personally identifiable
                        information from the Services from other users of the Services without
                        their express permission.
                    </p>
                    <p>
                        &#8226; You will not submit or post unsolicited promotional content,
                        advertising, political campaigns, contests, raffles or solicitations.
                    </p>
                    <p>
                        &#8226; You will not use the Services in a manner intended to damage,
                        disable, overburden or impair the Services or to disrupt or interfere with
                        another's use of the Services.
                    </p>
                    <p>
                        &#8226; You will not attempt to hack or otherwise gain unauthorized access
                        to the Services or accounts.
                    </p>
                    <p>
                        &#8226; You will not use high volume, automated, or electronic means to
                        access the Services (including without limitation robots, spiders, or
                        scripts).
                    </p>
                    <p>
                        &#8226; You will not affect the display of the Services through use of
                        framing, pop-ups or third-party ads.
                    </p>
                    <p>
                        &#8226; You will not transmit malware, software viruses, Trojan horses,
                        worms or any other malicious application to or through the Services.
                    </p>
                    <p>
                        &#8226; You will not threaten, dox, or otherwise harass other users or
                        experts.
                    </p>
                    <p>
                        &#8226; You will not submit or post information that is inaccurate, false,
                        fraudulent, or misleading, including submissions made under false
                        pretenses.
                    </p>
                    <p>
                        &#8226; You will not submit or post unlawful, harassing, libelous, abusive,
                        threatening, defamatory, vulgar, obscene, racist, harmful, inappropriate,
                        sexually explicit, or otherwise objectionable material of any kind,
                        including but not limited to posting any Content that promotes
                        discrimination, bigotry, racism, hatred, harassment or harm against any
                        individual or group; is violent or threatening or promotes violence or
                        actions that are threatening to any person or entity; and/or promotes
                        illegal or harmful activities or substances.
                    </p>
                    <p>
                        &#8226; You will not use any meta tags or other hidden text or metadata
                        utilizing a ChartOne trademark, logo URL or product name without ChartOne's
                        express written consent.
                    </p>
                    <p>
                        &#8226; You will not forge any TCP/IP packet header or any part of the
                        header information in any email or newsgroup posting, or in any way use the
                        Services or Content to send altered, deceptive or false source-identifying
                        information.
                    </p>
                    <p>
                        &#8226; You will not act in a manner that violates these Terms of Service.
                    </p>
                    <p>
                        &#8226; You will comply with applicable local, state, national or
                        international laws, statutes, ordinances, rules, regulations or ethical
                        codes governing your jurisdiction.
                    </p>
                    <p>
                        &#8226; You will notify us immediately of any content of the Services that
                        violates these Terms of Service.
                    </p>
                    <p>
                        We have the right to: (i) remove or refuse to post any Content for any or
                        no reason in our sole discretion; (ii) take any action with respect to any
                        Content that we deem necessary or appropriate in our sole discretion,
                        including if we believe that such Content violates these Terms of Service,
                        infringes any intellectual property right or other right of any person or
                        entity, threatens the personal safety of other users, experts, or the
                        public or could create liability for ChartOne; (iii) disclose your identity
                        or other information about you to any third party who claims that material
                        posted by you violates their rights, including their intellectual property
                        rights or their right to privacy; (iv) take appropriate legal action,
                        including without limitation, referral to law enforcement, for any illegal
                        or unauthorized use of the Services; and (v) terminate or suspend your
                        access to all or part of the Services for any or no reason, including
                        without limitation, any violation of these Terms of Service.
                    </p>
                    <p>
                        YOU WAIVE AND HOLD HARMLESS CHARTONE AND ITS AFFILIATES, LICENSEES AND
                        SERVICE PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY SUCH
                        PARTIES DURING OR AS A RESULT OF ITS INVESTIGATIONS AND FROM ANY ACTIONS
                        TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY SUCH PARTIES OR LAW ENFORCEMENT
                        AUTHORITIES.
                    </p>
                    <p>
                        We have no liability or responsibility to anyone for performance or
                        nonperformance of the activities described in this section.
                    </p>
                    <p>
                        <strong>Proprietary Rights</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        The Services and all past, present and future content of the Services,
                        including all software, hardware and technology used to provide the
                        Services (including our proprietary code and third-party software), user
                        interfaces, materials displayed or performed on the Services, such as text,
                        graphics, articles, photographs, images, illustrations and the design,
                        structure, sequence and "look and feel" of the Services, and all other
                        intellectual property, including all trademarks, service marks, logos, or
                        any other trade name, trademarks, service marks and other distinctive or
                        proprietary brand features of ChartOne, are (i) owned by ChartOne, its
                        licensors or other providers of such material, (ii) protected by United
                        States and international copyright, trademark, patent, trade secret and
                        other intellectual property or proprietary rights laws, (iii) are intended
                        solely for the personal, non-commercial use of our users and experts, and
                        (iv) may only be used in accordance with these Terms of Service.
                    </p>
                    <p>
                        Using our Services does not give you ownership of any intellectual property
                        rights in the Services or any content on the Services. You may not use
                        content from the Services, including Content, unless you obtain permission
                        from ChartOne and the expert who generated the content, if different from
                        ChartOne, or are otherwise permitted by law. These Terms of Service do not
                        grant you the right to use any of ChartOne's technology or intellectual
                        property. You may not remove, obscure, or alter any copyright or other
                        legal notices displayed in or along with the Services.
                    </p>
                    <p>
                        No right, title or interest in or to the Services or any content on the
                        Services is transferred to you, and all rights not expressly granted are
                        reserved by ChartOne. Any use of the Services not expressly permitted by
                        these Terms of Service is a breach of these Terms and may violate
                        copyright, trademark and other laws.
                    </p>
                    <p>
                        <strong>Claims of Copyright Infringement</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        If you believe that your copyrighted work has been unlawfully copied and is
                        accessible on the Services in a way that constitutes copyright
                        infringement, please send a notice of copyright infringement to:
                    </p>
                    <p>
                        ChartOne Media LLC
                    </p>
                    <p>
                        P.O. Box 356
                    </p>
                    <p>
                        Oyster Bay, NY 11771
                    </p>
                    <p>
                        Phone: (516) 900-1000
                    </p>
                    <p>
                        Email: info@tonenetworks.com
                    </p>
                    <p>
                        The notice should include:
                    </p>
                    <p>
                        &#8226; Your full name and electronic or physical signature.
                    </p>
                    <p>
                        &#8226; Your mailing address, phone number and email address (at which you
                        can be contacted by us or the alleged infringer).
                    </p>
                    <p>
                        &#8226; A statement that you are the owner, or are authorized to act on
                        behalf of the owner, of the copyright that is allegedly infringed, and that
                        the information in your notice is accurate.
                    </p>
                    <p>
                        &#8226; A statement that you have a good faith belief that the disputed use
                        of the copyrighted materials is not authorized by the copyright owner, its
                        agent or by law, such as fair use.
                    </p>
                    <p>
                        &#8226; A description of the copyrighted work(s) that you claim has been
                        infringed.
                    </p>
                    <p>
                        &#8226; A description of the location of the copyrighted materials on the
                        Services.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Electronic Delivery Statement and Your Consent</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You agree to receive legal notices and other information concerning
                        ChartOne or the Services electronically, including notice to any email
                        address that you may provide.
                    </p>
                    <p>
                        <strong>Term and Termination</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        These Terms of Service will remain in effect until terminated by you or
                        ChartOne. We reserve the right to terminate or change the Services or your
                        access to the Services, without notice, at any time and for any reason,
                        including your violation of these Terms of Service or for business reasons.
                        The disclaimer of warranties, limitation of liability, jurisdictional,
                        limitation of time to file claims, indemnification and arbitration
                        provisions survive any termination.
                    </p>
                    <p>
                        You agree that ChartOne may, for any reason and without notice to you,
                        immediately terminate or otherwise restrict your access to the Services.
                        ChartOne has no obligation to maintain, store, or transfer your information
                        or data that you have posted on or uploaded to the Services.
                    </p>
                    <p>
                        <strong>Disclaimer of Representations and Warranties</strong>
                        <strong></strong>
                    </p>
                    <p>
                        THE SERVICES AND ANY ASSOCIATED CONTENT ARE PROVIDED ON AN "AS IS" AND "AS
                        AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR
                        IMPLIED. NEITHER CHARTONE NOR ANY PERSON ASSOCIATED WITH CHARTONE MAKES ANY
                        REPRESENTATION OR WARRANTY WITH RESPECT TO THE COMPLETENESS, SECURITY,
                        RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE SERVICES OR ANY
                        ASSOCIATED CONTENT. WITHOUT LIMITING THE FOREGOING, NEITHER CHARTONE NOR
                        ANYONE ASSOCIATED WITH CHARTONE REPRESENTS OR WARRANTS THAT THE SERVICES OR
                        ANY ASSOCIATED CONTENT WILL BE ACCURATE, RELIABLE, ERROR-FREE, UPDATED OR
                        UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT THE SERVICES ARE FREE
                        OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SERVICES WILL OTHERWISE
                        MEET YOUR NEEDS OR EXPECTATIONS.
                    </p>
                    <p>
                        CHARTONE HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
                        IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY
                        WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR
                        PURPOSE.
                    </p>
                    <p>
                        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
                        LIMITED UNDER APPLICABLE LAW.
                    </p>
                    <p>
                        <strong>Limitation of Liability</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        YOUR USE OF THE SERVICES AND ANY CONTENT ON THE SERVICES IS AT YOUR SOLE
                        RISK AND DISCRETION. You may not assert claims for money damages arising
                        from the Services or any associated content against ChartOne, its
                        affiliates, licensors or service providers, or our respective employees,
                        contractors, officers, directors and agents. ChartOne, its affiliates,
                        licensors and service providers, and its respective employees, contractors,
                        officers, directors and agents shall not be liable for any direct,
                        indirect, special, incidental, consequential or punitive damages, including
                        but not limited to personal injury, pain and suffering, emotional distress,
                        or loss of revenue, profits, goodwill or data, whether caused by tort
                        (including negligence), breach of contract or otherwise, even if ChartOne
                        knew or should have known of the possibility of such damages, arising out
                        of or in connection with (i) your use, or inability to use, the Services or
                        any associated content or Content, (ii) any interaction with any third
                        party through or in connection with the Services, including experts and
                        other users, (iii) any information offered or provided within or through
                        the Services, or (iii) any other matter relating to the Services. In no
                        event shall ChartOne, its affiliates, licensors or service providers, or
                        its respective employees, contractors, officers, directors and agents be
                        liable to you in the aggregate (for all potential claims by you) for any
                        damages incurred in excess of one hundred dollars ($100). Because some
                        states or jurisdictions do not allow the exclusion or the limitation of
                        liability for consequential or incidental damages, in such states or
                        jurisdictions, ChartOne's liability shall be limited to the extent
                        permitted by law.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Indemnification</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You are solely legally liable if your use or misuse of the Services or any
                        associated content causes damage to the Services, to you, or to someone or
                        something else. You agree to defend, indemnify, and hold harmless ChartOne,
                        its affiliates, licensors and service providers, and its respective
                        employees, contractors, officers, directors and agents from and against all
                        liabilities, claims, damages, judgment, awards, losses, costs, expenses,
                        fines or fees (including attorney's fees and investigation costs), that
                        arise from or relate to your use or misuse of the Services, violation of
                        these Terms of Service or violation of a third party's rights. ChartOne
                        reserves the right, at ChartOne's own expense, to assume the exclusive
                        defense and control of any matter otherwise subject to indemnification by
                        you, in which event you agree to cooperate with ChartOne in asserting any
                        available defenses.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Limitation on Time to File Claims</strong>
                        <strong></strong>
                    </p>
                    <p>
                        Any cause of action or claim you may have arising out of or relating to
                        these Terms of Service or the Services must be commenced within one (1)
                        year after the cause of action accrues, otherwise, such cause of action is
                        permanently barred.
                    </p>
                    <p>
                        <strong>Choice of Law and Jurisdiction</strong>
                        <strong></strong>
                    </p>
                    <p>
                        You agree that the laws of the State of New York and U.S. federal law
                        govern these Terms of Service, your use of the Services, and any claim or
                        dispute that you may have against ChartOne, without regard to New York's
                        conflict of laws rules. You consent to the personal and exclusive
                        jurisdiction of the federal and state courts of New York, New York. The
                        United Nations Convention on Contracts for the International Sale of Goods
                        does not apply to this Agreement.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>Binding Arbitration</strong>
                        <strong></strong>
                    </p>
                    <p>
                        In the rare event you have a dispute with ChartOne, we encourage you to
                        contact us immediately so we can work together toward a satisfactory
                        resolution. If we cannot come to a resolution, you agree that any claims,
                        disputes, demands, counts, controversies, or causes of action between you
                        and ChartOne arising out of or relating to these Terms of Service, the
                        Services, including the enforceability of these Terms of Service or our
                        Privacy Policy or information practices will be finally and exclusively
                        resolved by binding arbitration on an individual basis only (except as
                        stated below). The arbitrator may not consolidate more than one person's
                        claims, and may not otherwise preside over any form of any class or
                        representative proceeding.
                    </p>
                    <p>
                        You understand that you are waiving your right to have your claims heard in
                        court by a judge or jury. An arbitration award is as enforceable as a court
                        order and is subject to only limited review by a judge. You also understand
                        and agree that this arbitration provision prevents you from participating
                        as a plaintiff or as a class member in any purported class action or
                        representative proceeding.
                    </p>
                    <p>
                        Arbitration will be subject to the Federal Arbitration Act, and shall be
                        commenced and conducted by the American Arbitration Association ("    <strong>AAA</strong>") under the Commercial Arbitration Rules and the
                        Supplementary Procedures for Consumer Related Disputes, as amended by this
                        provision, by one arbitrator that is acceptable to both parties. You can
                        find out more AAA and how to file an arbitration claim at www.adr.org or by
                        calling 800-778-7879.
                    </p>
                    <p>
                        Your arbitration fees and your share of arbitrator compensation shall be
                        governed by the AAA rules and, where appropriate, limited by the AAA
                        Consumer Rules. In the event you are able to demonstrate that the costs of
                        arbitration will be prohibitive as compared to the costs of litigation,
                        ChartOne will pay as much of your filing, administrative, and arbitrator
                        fees in connection with the arbitration as the arbitrator deems necessary
                        to prevent arbitration from being cost-prohibitive. In such a case, we will
                        make arrangements to pay all necessary fees directly to the AAA. If the
                        arbitrator determines the claim(s) you assert in the arbitration are
                        frivolous, you agree to reimburse ChartOne for all fees associated with the
                        arbitration paid by ChartOne on your behalf, which you otherwise would be
                        obligated to pay under the AAA's rules.
                    </p>
                    <p>
                        The arbitration will be conducted through written submission, unless the
                        arbitrator determines that a telephonic hearing is required. Except as
                        otherwise provided in these Terms of Service, you and ChartOne may litigate
                        in court to compel arbitration, stay proceedings pending arbitration, or to
                        confirm, modify, vacate or enter judgment on the award entered by the
                        arbitrator. In the event this arbitration provision is held unenforceable
                        by a court, or in the event AAA refuses to arbitrate the dispute, all
                        controversies, disputes, demands, counts, claims, or causes of action
                        between you and ChartOne shall be exclusively brought in the state or
                        federal courts of New York, New York.
                    </p>
                    <p>
                        Despite this provision, you may file a claim in a small claims court that
                        has jurisdiction to hear the matter.
                    </p>
                    <p>
                        <strong>Severability and Integration</strong>
                        <strong></strong>
                    </p>
                    <p>
                        These Terms of Service and any supplemental terms, policies, rules and
                        guidelines posted on the Services constitute the entire agreement between
                        you and ChartOne. If any part of the Terms of Service is held invalid or
                        unenforceable, that portion shall be construed in a manner consistent with
                        applicable law to reflect, as nearly as possible, the original intentions
                        of the parties, and the remaining portions shall remain in full force and
                        effect.
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        <strong>General Provisions</strong>
                        <strong></strong>
                    </p>
                    <p>
                        <strong> </strong>
                    </p>
                    <p>
                        You may not assign these Terms of Service without ChartOne's prior written
                        approval. ChartOne may assign these Terms without your consent to: (i) a
                        subsidiary or affiliate; (ii) an acquirer of ChartOne's business or assets;
                        or (iii) a successor by merger. Any purported assignment in violation of
                        this section shall be void. No joint venture, partnership, employment, or
                        agency relationship exists between you and ChartOne as a result of these
                        Terms of Service or your use of the Services. Our failure to enforce any
                        right or provision in these Terms of Service shall not constitute a waiver
                        of such right or provision unless acknowledged and agreed to by ChartOne in
                        writing.
                    </p>
                    <p>
                        <strong>Contact Information</strong>
                        <strong></strong>
                    </p>
                    <p>
                        The Services are operated by ChartOne LLC. All feedback, comments, requests
                        for technical support and other communications relating to the Services
                        should be directed to us at:
                    </p>
                    <p>
                        ChartOne Media LLC
                    </p>
                    <p>
                        P.O. Box 356
                    </p>
                    <p>
                        Oyster Bay, NY 11771
                    </p>
                    <p>
                        Phone: (516) 900-1000
                    </p>
                    <p>
                        Email: info@tonenetworks.com
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'TONE | Terms',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Terms'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Terms'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                corpId: 0,
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.success = true
                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                    })
                }
            },
            isHidden () {
                if (localStorage.getItem('corporateClientObject')) {
                    let corpObject = JSON.parse(localStorage.getItem('corporateClientObject'))
                    this.corpId = corpObject.corporationId
                }
                // let self = this
                console.log('isHidden () = corpId = ', this.corpId)
                console.log('isHidden () = ', this.corpId === 200)
                return this.corpId === 200
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p strong {
        font-weight: 900;
        color: #000;
    }

    .text-left p {
        font-size: 16px;
    }
    a {
        word-wrap:break-word;
    }
</style>



// WEBPACK FOOTER //
// Terms.vue?2afefa32